import { Box, useTheme } from '@mui/material';
import React from 'react';
import HeaderBar from '../components/common/HeaderBar';

interface MainLayoutProps {
    children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const theme = useTheme();
    return (
        <Box display={"flex"} flexDirection={"column"} height={"100%"} width={"100%"} justifyContent={"stretch"} alignItems={"stretch"} bgcolor={theme.palette.background.default}>
            <HeaderBar />
            {children}
        </Box>
    )
}

export default MainLayout;